// Find the length of the longest common subsequence between two strings
export const longestCommonSubsequence = (text1, text2) => {
  const dp = Array.from({ length: text1.length + 1 }, () => new Array(text2.length + 1).fill(0));
  for (let i = 1; i <= text1.length; i++) {
    for (let j = 1; j <= text2.length; j++) {
      if (text1[i - 1] === text2[j - 1]) {
        dp[i][j] = dp[i - 1][j - 1] + 1;
      } else {
        dp[i][j] = Math.max(dp[i - 1][j], dp[i][j - 1]);
      }
    }
  }
  return dp[text1.length][text2.length];
};

// Function to check if two texts are similar based on LCS and a specified threshold.
export const isTextSimilarByThreshold = (text1, text2, threshold = 0.8) => {
  const lcsLength = longestCommonSubsequence(text1, text2);
  const maxLength = Math.max(text1.length, text2.length);
  const isSimilar = (lcsLength / maxLength) >= threshold;
  return { isSimilar, lcsLength };
};

// Calculate the cosine similarity between two vectors.
export const getCosineSim = (A, B) => {
  let dotproduct = 0, mA = 0, mB = 0;
  for (let i = 0; i < A.length; i++) {
    dotproduct += A[i] * B[i];
    mA += A[i] * A[i];
    mB += B[i] * B[i];
  }
  const similarity = dotproduct / (Math.sqrt(mA) * Math.sqrt(mB));
  return similarity.toFixed(2);
};

// Function to calculate the cosine similarity scores between one embedding and multiple other embeddings.
export const calculateTextSimilarities = (targetEmbedding, otherEmbeddings) => {
  return otherEmbeddings.map(embedding => getCosineSim(targetEmbedding, embedding));
};

// Splits text into sentences considering newlines, periods, and preserving certain abbreviations.
export const splitIntoSentences = (text) => {
  // List of common abbreviations and references to preserve
  const preserveList = ['fig', 'e.g', 'i.e', 'etc', 'vs'];
  const preserveRegex = new RegExp(`\\b(${preserveList.join('|')})\\. `, 'gi');

  // Replace periods in preserved terms with a temporary marker
  const textWithMarkers = text.replace(preserveRegex, (match) =>
    match.replace('.', '{{DOT}}')
  );

  // Split into sentences, treating both newlines and period-space-capital as separators
  const sentences = textWithMarkers.split(/(?<=[.!?])\s+(?=[A-Z])|\n/);

  // Restore the original periods and trim whitespace
  return sentences.map((sentence) =>
    sentence.replace(/{{DOT}}/g, '.').trim()
  ).filter((sentence) => sentence !== '');
};